import { Space, Tag } from "antd";
import React from "react";
import styles from "./VendorDetails.module.scss";

export const VendorDetails = ({
  id,
  name, 
  email,
  contact,
  address,
  gst,
  pincode,
  category_name,
  catalogue,
}) => {
  return (
    <section className={styles.container}>
      <div className={styles.title}>
        {name}
      </div>
      {category_name && (
        <Space style={{ marginBottom: "1rem" }} wrap>
          {category_name?.map((category) => category && (
            <Tag key={category}>
              {category.trim()}
            </Tag>
          ))}
        </Space>
      )}
      <div className={styles.sectionTitle}>
        Contact Details
      </div>
      {email && (
        <div className={styles.section}>
          <div className={styles.label}>
            Email
          </div>
          <div className={styles.value}>
            {email}
          </div>
        </div>
      )}
      {contact && (
        <div className={styles.section}>
          <div className={styles.label}>
            Phone
          </div>
          <div className={styles.value}>
            {contact}
          </div>
        </div>
      )}
      {address && (
        <div className={styles.section}>
          <div className={styles.label}>
            Address
          </div>
          <div className={styles.value}>
            {address}
          </div>
        </div>
      )}
      {catalogue && catalogue.filter(Boolean).length > 0 && (
        <div className={styles.sectionTitle}>Catalogue</div>
      )}
      {catalogue && (
        catalogue.map((catalogue, idx) => (
          <div key={idx} className={styles.section}>
            <div className={styles.label}>
              Catalogue {idx + 1}
            </div>
            <div className={styles.value}>
              <a href={`https://mysite-powo-pdfs.s3.ap-south-1.amazonaws.com/media/${catalogue}`} target="_blank" rel="noreferrer">
                https://mysite-powo-pdfs.s3.ap-south-1.amazonaws.com/media/{catalogue}
              </a>
            </div>
          </div>
        ))
      )}
    </section>
  )
};
